import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import '../html-template/styles.css';
import '../html-template/tool.scss';

import { range, keyBy } from 'lodash';

import axios from 'axios';

class ToolScreen extends Component {
    constructor(props){
        super(props);

        this.model_data = {
            '1': 12,
            '2': 9,
            '3': 10,
            '4': 9,
            '5': 8,
            '6': 11,
            '7': 11,
            '8': 10,
            '9': 17,
        };

        this.model_fixed = {
            //'1': {
            //    7: 64,
            //    10: 68,
            //},
            '3': {
                5: 64,
                6:64,
                8: 68,
            },
            '4': {
                5: 64,
                4: 64,
                9: 68,
            },
            '5': {
                6: 65,
                7: 65,
                5: 68,
                8: 24,
            },
            '6': {
                8: 64,
                9: 64,
                10: 64,
                11: 68,
            },
            '7': {
							4: 64,
							7: 63,
							8: 68
            //    8: 64,
            //    9: 64,
            //    13: 68,
            //    12: 64,
            //    11: 64,
            },
            '8': {
                7: 64,
                9: 64,
                8: 68,
            },
            '9': {
                1: 64,
                4: 64,
                5: 64,
                8: 64,
                10: 68,
                11: 68,
                12: 68,
                13: 64,
                15: 68,
                16: 68,
                17: 68,
            }
        }

        this.color_group_label = {
            "1": "Đen",
            "2": "Xanh dương",
            "3": "Đồng - gold",
            "4": "Xanh lá",
            "5": "Cam - vàng - hồng",
            "6": "Đỏ",
            "7": "Xám",
            "8": "Trắng - bạc",
            "9": "Trắng",
            "10": "Đen",
            "11": "Bạc",
            "12": "Xám"
        }


        if(this.props.location && this.props.location.state){
            const { resp, current_color, current_model, attrs, current_attr } = this.props.location.state;
            const model = current_model ? current_model : '1';
            const parts = range(1, this.model_data[model]+1).map((i) => { 
                let colr = undefined;

                if(this.model_fixed.hasOwnProperty(model) && this.model_fixed[model].hasOwnProperty(i)){
                    colr = this.model_fixed[model][i];
                }
                    
                return {
                    code: i.toString(),
                    color: colr ? colr.toString() : (current_color ? current_color : '1')
                }
            });

            this.state = {
                phase: 1,
                colors: [],
                current_part: undefined,
                num_of_part: this.model_data[model],
                model: model,
                parts: keyBy(parts, 'code'),
                resp,
                change_all: true,
                current_step: 1,
                num_of_steps: 3,
							current_attr: current_attr,
                steps_completed: [],
                dream_color: current_color,
                base_color: current_color,
							attrs: attrs,
                saving: false,
                successful: false,
							selected_parts: [],
							done: false
            }

					this.part_names = {
						'1': [
							{name: 'Dàn áo thân sau'},
							{name: 'Thân xe giữa 1'},
							{name: 'Thân xe giữa 2'},
							{name: 'Dàn gác chân'},
							{name: 'Bửng xe'},
							{name: 'Thân xe giữa 3'},
							{name: 'Mặt nạ dưới'},
							{name: 'Mặt nạ lớn'},
							{name: 'Dè chắn bùn'},
							{name: 'Mâm xe'},
							{name: 'Mặt nạ bên'},
							{name: 'Mặt nạ nhỏ'},
						],
						'2': [
							{name: 'Dàn áo thân sau'},
							{name: 'Bửng xe 1'},
							{name: 'Dè chắn bùn'},
							{name: 'Mặt nạ bên'},
							{name: 'Thân xe giữa 1'},
							{name: 'Thân xe giữa 2'},
							{name: 'Thân xe giữa 3'},
							{name: 'Mặt nạ lớn'},
							{name: 'Bửng xe 2'},
							
						],
						'3': [
							{name: 'Dè chắn bùn'},
							{name: 'Mặt nạ lớn'},
							{name: 'Thân xe giữa 1'},
							{name: 'Bửng xe'},
							{name: 'Thân xe giữa 2'},
							{name: 'Sàn để chân'},
							{name: 'Dàn áo thân sau'},
							{name: 'Mâm xe'},
							{name: 'Dàn gác chân'},
							{name: 'Mặt nạ bên'},
						],
						'4': [
							{name: 'Bửng xe'},
							{name: 'Mặt nạ lớn'},
							{name: 'Mặt nạ bên'},
							{name: 'Sàn để chân'},
							{name: 'Thân xe giữa 1'},
							{name: 'Dè chắn bùn'},
							{name: 'Dàn áo thân sau'},
							{name: 'Thân xe giữa 2'},
							{name: 'Mâm xe'},
						],
						'5': [
							{name: 'Dàn áo thân sau'},
							{name: 'Bửng xe'},
							{name: 'Dè chắn bùn'},
							{name: 'Mặt nạ bên'},
							{name: 'Mặt nạ lớn'},
							{name: 'Thân xe giữa 1'},
							{name: 'Thân xe giữa 2'},
							{name: 'Mâm xe'},
						],
						'6': [
							{name: 'Dè chắn bùn'},
							{name: 'Mặt nạ bên'},
							{name: 'Mặt nạ lớn'},
							{name: 'Dàn áo thân sau'},
							{name: 'Thân xe giữa 1'},
							{name: 'Mặt nạ nhỏ'},
							{name: 'Bửng xe '},
							{name: 'Thân xe giữa 2'},
							{name: 'Thân xe giữa 3'},
							{name: 'Thân xe giữa 4'},
							{name: 'Mâm xe'},
						],
						'7': [
							{name: 'Dè chắn bùn'},
							{name: 'Mặt nạ lớn'},
							{name: 'Bửng xe'},
							{name: 'Mặt nạ nhỏ'},
							{name: 'Mặt nạ bên'},
							{name: 'Thân xe giữa 1'},
							{name: 'Thân xe giữa 2'},
							{name: 'Thân xe giữa 3'},
							{name: 'Dè chắn bùn sau'},
							{name: 'Dàn áo thân sau'},
							{name: 'Mâm xe'},
						],
						'8': [
							{name: 'Dàn áo thân sau'},
							{name: 'Thân xe giữa 1'},
							{name: 'Bửng xe'},
							{name: 'Mặt nạ lớn'},
							{name: 'Mặt nạ nhỏ'},
							{name: 'Mặt nạ bên'},
							{name: 'Thân xe giữa 2'},
							{name: 'Mâm xe'},
							{name: 'Sàn để chân'},
							{name: 'Dè chắn bùn'},
						],
						'9': [
							{name: 'Mâm xe'},
							{name: 'Dè chắn bùn'},
							{name: 'Mặt nạ lớn'},
							{name: 'Mặt nạ giữa'},
							{name: 'Mặt nạ nhỏ'},
							{name: 'Mặt nạ bên'},
							{name: 'Bửng xe 1'},
							{name: 'Bửng xe 2'},
							{name: 'Bửng xe 3'},
							{name: 'Thân giữa xe 1'},
							{name: 'Thân giữa xe 2'},
							{name: 'Thân giữa xe 3'},
							{name: 'Dàn gác chân'},
							{name: 'Dàn áo thân sau'},
							{name: 'Ốp máy sau 1'},
							{name: 'Ốp máy sau 2'},
							{name: 'Dè chắn bùn sau'},
						]
					};
            this.line_data = {
/*                '1': [
									{part:1, x1:189, y1:248, x2:40, y2:30 },
                        {part:2, x1:515, y1:282, x2:280, y2:30 },
                        {part:3, x1:370, y1:416, x2:100, y2:30 },
                        {part:4, x1:594, y1:310, x2:520, y2:30 },
                        {part:5, x1:529, y1:169, x2:460, y2:30 },
                        {part:6, x1:444, y1:142, x2:400, y2:30 },
                        {part:7, x1:409, y1:354, x2:160, y2:30 },
                        {part:8, x1:408, y1:301, x2:220, y2:30 },
                        {part:9, x1:487, y1:225, x2:340, y2:30 },
                        {part:10, x1:623, y1:387, x2:580, y2:30 },
                ],
								*/
                '1': [
									{part:1, x1:172, y1:311, x2:40, y2:30 },
                        {part:2, x1:277, y1:541, x2:160, y2:30 },
                        {part:3, x1:234, y1:458, x2:100, y2:30 },
                        {part:4, x1:253, y1:395, x2:220, y2:30 },
                        {part:5, x1:415, y1:368, x2:340, y2:30 },
                        {part:6, x1:305, y1:344, x2:280, y2:30 },
                        {part:7, x1:434, y1:161, x2:400, y2:30 },
                        {part:8, x1:512, y1:230, x2:580, y2:30 },
                        {part:9, x1:566, y1:420, x2:640, y2:30 },
                        {part:10, x1:577, y1:535, x2:760, y2:30 },
                        {part:11, x1:489, y1:125, x2:520, y2:30 },
                        {part:12, x1:441, y1:102, x2:460, y2:30 },
                ],
                '2': [
                        {part:1, x1:201, y1:205, x2:40, y2:30 },
                        {part:2, x1:414, y1:305, x2:100, y2:30 },
                        {part:3, x1:580, y1:211, x2:400, y2:30 },
                        {part:4, x1:488, y1:87, x2:460, y2:30 },
                        {part:5, x1:346, y1:226, x2:160, y2:30 },
                        {part:6, x1:473, y1:165, x2:280, y2:30 },
                        {part:7, x1:449, y1:118, x2:340, y2:30 },
                        {part:8, x1:521, y1:121, x2:520, y2:30 },
                        {part:9, x1:454, y1:239, x2:220, y2:30 },
                ],
                "3": [

                        {part:1, x1:351, y1:367, x2:520, y2:30 },
                        {part:2, x1:280, y1:193, x2:400, y2:30 },
                        {part:3, x1:190, y1:353, x2:340, y2:30 },
                        {part:4, x1:258, y1:290, x2:460, y2:30 },
                        {part:5, x1:133, y1:468, x2:100, y2:30 },
                        {part:6, x1:137, y1:387, x2:160, y2:30 },
                        {part:7, x1:77, y1:288, x2:40, y2:30 },
                        {part:8, x1:356, y1:520, x2:580, y2:30 },
                        {part:9, x1:148, y1:460, x2:220, y2:30 },
                        {part:10, x1:235, y1:115, x2:280, y2:30 },
                ],
                    "4": [
                        {part:1, x1:344, y1:284, x2:340, y2:30 },
                        {part:2, x1:407, y1:194, x2:400, y2:30 },
                        {part:3, x1:331, y1:113, x2:160, y2:30 },
                        {part:4, x1:281, y1:443, x2:280, y2:30 },
                        {part:5, x1:253, y1:341, x2:220, y2:30 },
                        {part:6, x1:466, y1:321, x2:460, y2:30 },
                        {part:7, x1:161, y1:288, x2:40, y2:30 },
                        {part:8, x1:257, y1:470, x2:100, y2:30 },
                        {part:9, x1:487, y1:479, x2:520, y2:30 },
                    ],
                "5": [
                        {part:1, x1:168, y1:326, x2:40, y2:30 },
                        {part:2, x1:361, y1:284, x2:220, y2:30 },
                        {part:3, x1:498, y1:323, x2:460, y2:30 },
                        {part:4, x1:358, y1:116, x2:280, y2:30 },
                        {part:5, x1:451, y1:199, x2:400, y2:30 },
                        {part:6, x1:247, y1:494, x2:100, y2:30 },
                        {part:7, x1:273, y1:398, x2:160, y2:30 },
                        {part:8, x1:498, y1:480, x2:340, y2:30 },
                ],
                "6": [
                        {part:1, x1:565, y1:330, x2:580, y2:30 },
                        {part:2, x1:418, y1:103, x2:400, y2:30 },
                        {part:3, x1:481, y1:208, x2:460, y2:30 },
                        {part:4, x1:151, y1:273, x2:40, y2:30 },
                        {part:5, x1:302, y1:355, x2:220, y2:30 },
                        {part:6, x1:495, y1:185, x2:520, y2:30 },
                        {part:7, x1:379, y1:374, x2:340, y2:30 },
                        {part:8, x1:307, y1:320, x2:280, y2:30 },
                        {part:9, x1:230, y1:356, x2:160, y2:30 },
                        {part:10, x1:218, y1:396, x2:100, y2:30 },
                        {part:11, x1:569, y1:444, x2:640, y2:30 },
                ],
                "7": [
                        {part:1, x1:98, y1:355, x2:40, y2:30 },
                        {part:2, x1:149, y1:222, x2:100, y2:30 },
                        {part:3, x1:244, y1:262, x2:160, y2:30 },
                        {part:4, x1:245, y1:112, x2:220, y2:30 },
                        {part:5, x1:326, y1:112, x2:280, y2:30 },
                        {part:6, x1:434, y1:289, x2:340, y2:30 },
                        {part:7, x1:488, y1:309, x2:400, y2:30 },
                        {part:8, x1:502, y1:336, x2:460, y2:30 },
                        {part:9, x1:547, y1:289, x2:520, y2:30 },
                        {part:10, x1:574, y1:250, x2:580, y2:30 },
                        {part:11, x1:628, y1:376, x2:640, y2:30 },
                ],
							/*"7": [
                        {part:1, x1:100, y1:344, x2:40, y2:30 },
                        {part:2, x1:184, y1:213, x2:100, y2:30 },
                        {part:3, x1:314, y1:93, x2:280, y2:30 },
                        {part:4, x1:278, y1:301, x2:160, y2:30 },
                        {part:5, x1:582, y1:211, x2:640, y2:30 },
                        {part:6, x1:265, y1:63, x2:220, y2:30 },
                        {part:7, x1:324, y1:116, x2:340, y2:30 },
                        {part:8, x1:411, y1:328, x2:400, y2:30 },
                        {part:9, x1:449, y1:284, x2:460, y2:30 },
                        {part:10, x1:601, y1:237, x2:700, y2:30 },
                        {part:11, x1:506, y1:310, x2:580, y2:30 },
                        {part:12, x1:478, y1:372, x2:520, y2:30 },
                        {part:13, x1:616, y1:343, x2:760, y2:30 },
								],*/
                "8": [
                        {part:1, x1:100, y1:258, x2:40, y2:30 },			
                        {part:2, x1:248, y1:485, x2:100, y2:30 },			
                        {part:3, x1:346, y1:306, x2:280, y2:30 },			
                        {part:4, x1:425, y1:208, x2:460, y2:30 },			
                        {part:5, x1:371, y1:72, x2:400, y2:30 },			
                        {part:6, x1:344, y1:114, x2:340, y2:30 },			
                        {part:7, x1:254, y1:355, x2:160, y2:30 },			
                        {part:8, x1:499, y1:486, x2:580, y2:30 },			
                        {part:9, x1:288, y1:440, x2:220, y2:30 },			
                        {part:10, x1:502, y1:352, x2:520, y2:30 },
                    
                ],
                "9": [

                        {part:1, x1:57, y1:487, x2:20, y2:120 },  	
                        {part:2, x1:75, y1:374, x2:70, y2:30 }, 		
                        {part:3, x1:142, y1:229, x2:120, y2:30 }, 		
                        {part:4, x1:175, y1:172, x2:170, y2:30 }, 		
                        {part:5, x1:220, y1:121, x2:220, y2:30 }, 		
                        {part:6, x1:252, y1:119, x2:270, y2:30 }, 		
                        {part:7, x1:256, y1:268, x2:320, y2:30 }, 		
                        {part:8, x1:279, y1:351, x2:370, y2:30 }, 		
                        {part:9, x1:285, y1:460, x2:420, y2:30 }, 		
                        {part:10, x1:346, y1:397, x2:470, y2:30 },
                        {part:11, x1:385, y1:467, x2:520, y2:30 },
                        {part:12, x1:434, y1:332, x2:570, y2:30 },
                        {part:13, x1:462, y1:377, x2:620, y2:30 },
                        {part:14, x1:522, y1:284, x2:670, y2:30 },
                        {part:15, x1:572, y1:423, x2:720, y2:30 },
                        {part:16, x1:604, y1:362, x2:720, y2:120 },
                        {part:17, x1:657, y1:330, x2:720, y2:220 },
                    
                ]
            };

        }else{
            this.state = {};
        }


        this.colorClicked = this.colorClicked.bind(this);
        this.partClicked = this.partClicked.bind(this);
        this.partDesClicked = this.partDesClicked.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.handleResetToBaseColor = this.handleResetToBaseColor.bind(this);
    }

    calc_line_point(left, top, width, height){
        return { x1: left+width/2, y1: top+height/2 }; 
    }


    componentDidMount(){
			if(this.state.attrs && this.state.attrs.length > 0){
        axios.get(process.env.PUBLIC_URL + "/assets/json/colors.json")
            .then(resp => {
                this.setState({
                    colors: resp.data
                });
            });
			}
    }

    handleResetToBaseColor(){
        if(this.state.successful) return;
        this.setState((prevState) => {
            let parts = { ...prevState.parts};
            let model = prevState.model;
            if(!this.model_fixed.hasOwnProperty(model)){
                Object.keys(parts).forEach(key => {
                    parts[key].color = prevState.base_color
                });
            }else{
                let fixed_parts = this.model_fixed[model];
                Object.keys(parts).forEach(key => {

                    if(fixed_parts.hasOwnProperty(key)){
                        parts[key].color = fixed_parts[key];
                    }else{
                        parts[key].color = prevState.base_color;
                    }
                });
            }
            return {
                parts: parts
            }
        });
    }

    colorClicked(e){
        const color_code = e.target.getAttribute('data-code');

        if(this.state.successful) return;

        if(this.state.change_all){
            const parts = {...this.state.parts};
            Object.keys(parts).forEach((key, index) => {
                var fixed = false;
                if(this.model_fixed.hasOwnProperty(this.state.model)){
                    if(this.model_fixed[this.state.model].hasOwnProperty(parseInt(key))){
                        fixed = true;
                    }
                }
                if(fixed === false){
                    parts[key].color = color_code;
                }
            });
              
            this.setState({parts: parts});
        }else{
            if(this.state.current_part && this.state.current_part !== ''){
                const parts = {...this.state.parts};
                parts[this.state.current_part].color = color_code;

                this.setState({parts: parts});
            }else{
                alert("Vui lòng chọn bộ phận trước khi chọn màu");
            }
        }
    }

	partInList(parts, part){
		return parts.filter(c => c.part == part).length > 0;
	}

	selectPart = (part) => {
			const {selected_parts, model} = this.state;
		const part_name = {part, name: this.part_names[model][Number(part)-1].name};
				if(selected_parts.length < 3 && !this.partInList(selected_parts,part)){
					this.setState((state) => {
						return	{selected_parts: state.selected_parts.concat([part_name]) }
					});
				}else if(this.partInList(selected_parts,part)){
						this.setState((state) => {
							return	{selected_parts: state.selected_parts.filter((el) => el.part != part) }
						});
					}
    }

    partDesClicked(e){
        const part = e.target.getAttribute('data-part');
        this.setState((prev_state) => {
            if(prev_state.current_part !== part){
                return {current_part: part};
            }else{
                return {current_part: undefined};
            }
        });
    }
    partClicked(e){
        if(this.state.successful) return;
        const part = e.target.getAttribute('data-part');

        this.setState((prev_state) => {
            if(prev_state.current_part !== part){
                return {current_part: part};
            }else{
                return {current_part: undefined};
            }
        });
    }

    handleNext(){
        let base_color = this.state.base_color;
        if(this.state.current_step === 1){
            base_color = this.state.parts['1'].color
        }
        if(this.state.current_step < this.state.num_of_steps){
					if(this.state.current_step == 2 && this.state.selected_parts.length == 0){
					  if(!window.confirm("Bạn có chắc chắn không chọn bộ phận nào để đổi màu?")){
						return;
						}
					}
            this.setState((prev) => {
                return {
                    steps_completed: [...prev.steps_completed, prev.current_step],
                    current_step: prev.current_step + 1,
                    change_all: prev.current_step === 2 ? false : true,
                    base_color: base_color
                }
            });
        }else{
            // On completed
            const { model, resp, dream_color, base_color, selected_parts, parts, phase, current_attr} = this.state;

					  if(window.confirm("Bạn hoàn thành chọn màu xe cho yếu tố " + current_attr.label +"?"))
            this.setState({saving: true}, () => {
                axios.post('http://api.cimigo.com/api/c7220/paint', {
                    phase: phase.toString(),
                    model: model.toString(),
                    resp,
                    dream_color: base_color.toString(),
                    base_color: base_color.toString(),
                    parts,
									//2023
									  attr: current_attr.code,
									  selected_parts: selected_parts
                }).then(resp => {
                    //window.alert("Lưu thành công.");
									this.setState(() => 
										{
									const newAttrs = this.state.attrs.filter(a => a.code != this.state.current_attr.code);
									let done=false;
									if(newAttrs.length == 0){
													done = true;
									}
											return {done: done, successful: true, current_part: undefined}
										});
                    //this.setState({current_part: undefined});

                }).catch(err => {
                    alert("Có lỗi khi lưu dữ liệu, liên hệ IT.");
                    console.log(err);
                });
            });

        }
    }

    handleLogout(){
        let confirm = window.confirm("Bạn có chắc chắn muốn đăng xuất?");
        if(confirm){
            this.props.history.replace({
                pathname: '/'
            });
        }
    }

	handleResetAttr = () => {
      if(window.confirm("Bạn có chắc chắn muốn làm lại từ đầu yếu tố này?")){
			this.props.history.push({
					pathname: '/tool',
					state: { 
							resp: {...this.state.resp},
							current_model: this.state.model,
							current_color: "1",
						attrs: this.state.attrs,
						current_attr: this.state.current_attr 
					}
			});
		window.location.reload();
			}
	}
	handleNextAttr = () => {
		const newAttrs = this.state.attrs.filter(a => a.code != this.state.current_attr.code);
		console.log(newAttrs);
		if(newAttrs.length > 0){
			this.props.history.push({
					pathname: '/tool',
					state: { 
							resp: {...this.state.resp},
							current_model: this.state.model,
							current_color: "1",
						attrs: newAttrs,
						current_attr: newAttrs[0]
					}
			});
		window.location.reload();
		}
	}

    render() {
        if(!this.state.resp) return <Redirect to="/" />;
        if(this.state.successful){
					return (
						<div className="done-attr">
							{this.state.done ? 
								<div>Đáp viên {this.state.resp.resp_name} đã hoàn thành tất cả yếu tố.</div>
							:<div>Đáp viên {this.state.resp.resp_name} đã chọn xong yếu tố <strong>{this.state.current_attr.label}</strong></div>
							}
							<div>
							{this.state.done ? 
                <a href="/" title="home" className="btn">Về trang chủ <i className="icon ion-md-arrow-round-forward"></i></a>    
								: <button onClick={this.handleNextAttr} title="home" className="btn btn--primary">Tiếp theo: {this.state.attrs[1].label} <i className="icon ion-md-arrow-round-forward"></i></button>    
							}
							</div>
						</div>
					);
				}

        const { colors, selected_parts,  current_part, current_step, model } = this.state;
                            let paint_header = "";
				if(current_step == 1) paint_header = (<span>
																Vui lòng chọn màu sắc chủ đạo mà Anh/Chị nghĩ sẽ phù hợp với yếu tố 
															<strong className="attr"> {this.state.current_attr.label}</strong>
															</span>);
			else if(current_step ==2) paint_header = "Anh/Chị có thể chọn tối đa 3 bộ phận mà Anh/Chị muốn thay đổi màu.";
			else if(current_step ==3) {
				if(selected_parts.length > 0)
				paint_header = "Bây giờ, Anh/Chị hãy phối màu cho các bộ phận mà Anh/Chị vừa chọn";
				else paint_header = "Vui lòng nhấn nút hoàn thành để kết thúc quá trình chọn màu cho yếu tố " +this.state.current_attr.label;
			}
        let part_images = [];
        for(var i = 1;i<=this.state.num_of_part;i++){
					let is_current = "";
					if(current_step == 2 && this.partInList(selected_parts, i)){
						is_current = "scurrent";
					}else if(current_part == i){
						is_current = "current";	
					}
            part_images.push(<img key={i} 
                src={process.env.PUBLIC_URL + '/assets/models/'+this.state.model+'/'+i+'_'+this.state.parts[i].color+'.png'} 
                alt="full model"
                className={`model-${this.state.model}-part-${i} part ${is_current}`}
                data-part={i}
                onClick={this.partClicked}/>
            );
        }
    return (
        <div className="tool">
            <header className="tool-header">
                <div className="info">{`Đáp viên: ${this.state.resp.resp_name} (MS: ${this.state.resp.resp_code})`}
                    <button onClick={this.handleLogout}><i className="icon ion-md-log-out"></i>Đăng xuất</button>
									<span className="attr-group"><strong className="attr"> Yếu tố: {this.state.current_attr.label}</strong>

										<button title="Bắt đầu lại" className="reset-attr" onClick={this.handleResetAttr}><i className="icon ion-md-refresh"></i></button>
									</span>
                    { !this.state.successful && this.state.current_step === 3 &&
                    <button onClick={this.handleResetToBaseColor} className="reset-color"><i className="icon ion-md-refresh"></i>Reset màu</button>
                    }
        </div>
                {

                    range(1, this.state.num_of_steps+1).map((i) => 
                        
                        <div key={i} className={"step" + (this.state.current_step === i ? " current" : "") + (this.state.steps_completed.indexOf(i) !== -1 ? " completed" : "")}><i className={"icon ion-md-"+ (this.state.steps_completed.indexOf(i) !== -1 ? "checkmark-circle" : "arrow-dropright-circle")+" left"}></i>Bước {i}</div>
                    )
                }
                <button onClick={this.handleNext} title="complete" className="btn btn--primary" disabled={this.state.saving?"disabled":""}>{
                    this.state.current_step === this.state.num_of_steps ? (this.state.successful ? "Đã lưu":"Hoàn thành") : "Tiếp theo"
                }<i className={ this.state.successful ? "icon ion-md-checkmark": "icon ion-md-arrow-round-forward"}></i></button>    
            </header>
            <main className="tool-main">
                <div className="left-panel">
                        <figure
													style={{ pointerEvents: current_step == 1 ? "none" : "auto" }}
													className="model-image model-1">
                            <img src={process.env.PUBLIC_URL + '/assets/models/'+this.state.model+'/full.png'} alt="full model" className={"model-"+this.state.model+"-full"}/>
                            {
                                part_images.map((img) => img)
                            }
                            
                        </figure>
                        { this.state.current_step === 2 &&
                        <svg width="100%" height="100%">
                            {this.line_data[this.state.model].map((line, index) => {
                                return <line key={line.part} x1={line.x1} y1={line.y1} x2={line.x2} y2={line.y2} />
                            }
                            )}

                            {this.line_data[this.state.model].map((line, index) => {
                                return (
                                    <g key={line.part} className={`part-des ${this.partInList(selected_parts, line.part) ? 'current' : ''}`}>
                                        <circle cx={line.x2} cy={line.y2} r="18" />
																			{/*<text x={line.x2} y={line.y2} fontSize="15" textAnchor="middle" alignmentBaseline="middle" dy="1">{index+1}</text>*/}
																			<circle cx={line.x2} cy={line.y2} r="18" data-part={line.part} className="trans" onClick={() => this.selectPart(line.part)}/>
                                    </g>
                                )
                            }
                            )}
                        </svg>
                        }
									{ this.state.current_step === 3 && 
										<div className="part_name"
											style={{display: current_part ? "unset" : "none"}}
											>{current_part ? this.part_names[model][current_part-1].name : ""}</div>
									}
                        { this.state.current_step === 3 &&
                        <svg width="100%" height="100%">
															{this.line_data[this.state.model].map((line, index) => {
																if(this.partInList(selected_parts, line.part))
                                return <line key={line.part} x1={line.x1} y1={line.y1} x2={line.x2} y2={line.y2} />
                            }
                            )}

                            {this.line_data[this.state.model].map((line, index) => {
																if(this.partInList(selected_parts, line.part))
                                return (
                                    <g key={line.part} className={`part-des ${this.state.current_part === line.part.toString() ? 'current' : ''}`}>
                                        <circle cx={line.x2} cy={line.y2} r="18" />
																			{/*
                                        <text x={line.x2} y={line.y2} fontSize="15" textAnchor="middle" alignmentBaseline="middle" dy="1">{index+1}</text>
																				*/
																			}
                                        <circle cx={line.x2} cy={line.y2} r="18" data-part={line.part} className="trans" onClick={this.partDesClicked}/>
                                    </g>
                                )
                            }
                            )}
                        </svg>
                        }
                </div>
                <div className="right-panel">
                    <div className="paint-tool">
                        <div className="paint-tool__header">
													{paint_header}
                        </div>
											{(current_step ==1 || (current_step == 3 && selected_parts.length > 0)) &&  colors.map((color_group) => 
                        <ul key={color_group[0].Group_Code} className="paint-tool__color">
                            { 
                                color_group.map((color) => 
                                    <li key={color.Code}>
                                        <span 
                                            className={"color__item" +( 
																								(current_part && this.state.parts[current_part].color == color.Code) ? " current" : "")

																					}
                                            data-code={color.Code} 
                                            onClick={this.colorClicked} 
                                            style={{
                                                backgroundColor: `hsl(${color.H},${color.S}%,${color.B}%)`,
                                                color: color.B < 51 ? '#FFF' : '#333'
                                            }}>{color.Code}
                                        </span>
                                    </li>
                                )
                            }
                            <li className="color-label">{this.color_group_label[color_group[0].Group_Code]}</li>
                        </ul>
                        )}
											{
												current_step == 2 && selected_parts.length > 0 && (
													<div className="selected-parts">
														<h5>Các bộ phận đã chọn:</h5>
														<ul>
															{ 
																selected_parts.map((p,i) => <li key={i}>{p.name} <span className="remove" onClick={() => this.selectPart(p.part)}>(xóa)</span></li>)
															}
														</ul>

													</div>
												)
											}
                    </div>
                </div>
            </main>
        </div>
    );
  }
}

export default ToolScreen;
